<template>
  <Card>
    <div class="d-flex align-center justify-space-between">
      <header>
        <strong class="text-h3 font-weight-bold" v-text="title"/>
        <div class="mt-4 d-flex gap-lg align-center">
          <Status iconSize="dense" class="d-inline" v-bind="statusProps"/>
          <span class="text-paragraph-2 font-weight-medium" v-text="usage"/>
        </div>
      </header>
      <Button v-bind="buttonProps" color="primary" :label="adminSites" :to="manageRoute"/>
    </div>
  </Card>
</template>

<script>
import { Button, Card, Status, useLocale, useRenamePath } from '@locaweb/design-system-vue'
import { PlanStatus } from '@enums/Plan'
import { SitesRoutesPath } from '@/views/site/router'
import { useStatus } from '@/functions/useStatus'

export default {
  name: 'PlanCard',
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  components: {
    Card,
    Status,
    Button
  },
  computed: {
    buttonProps () {
      let disabled = { disabled: false }
      if (!this.isActive) {
        disabled = { disabled: true }
      }
      return disabled
    }
  },
  setup (props) {
    const t$ = useLocale('plans.plan')
    const title = t$.name[props.plan.contract_key]
    const usage = t$.usage.replaceValues({ ...props.plan.consumption })
    const adminSites = t$.adminSites
    const isActive = props.plan.status === PlanStatus.ACTIVE

    const statusProps = useStatus(props.plan.status, t$.status)

    const manageRoute = SitesRoutesPath.LISTAR.path.replace(':id', props.plan.id)
    const { addPathName } = useRenamePath()
    addPathName({
      path: manageRoute,
      name: title
    })

    return {
      t$,
      title,
      usage,
      adminSites,
      statusProps,
      isActive,
      manageRoute
    }
  }
}
</script>
